import Vue from 'vue'
import Vuex from 'vuex'


import axios from 'axios';
import * as firebase from 'firebase/app';

// eslint-disable-next-line
import * as firebaseAuth from 'firebase/auth';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    selectedBusiness:-1,
    userLoaded: false,
    idToken: "",
    locationsLoaded: false,
    locations:[],
    url:"",
    accountDetails: -1,
    adminUsers:[],
  },
  mutations: {

    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
    },
    setBusinessId(state, Payload){
      state.selectedBusiness = Payload;
      state.locations=[];
    },
    addLocation(state, Payload){
      state.locations.push(Payload);
    },
    setLocation(state, Payload){
      state.locations.find(location => location.id === Payload.LocationID).title = Payload.UpdateLocationDTO.newTitle;
    },
    setIdToken(state, newToken){
      state.idToken = newToken;
    },
    setUrl(state, newUrl){
      state.url = newUrl;
    },
    loadLocations(state, newLocations){
      state.locations=newLocations;
    },
    setAccount(state, newAccount){
      state.accountDetails = newAccount;
      state.selectedBusiness = newAccount.businesses[0].businessID;
    },
    setUserLoaded(state, newValue){
      state.userLoaded = newValue;
    },
    setAdminUsers(state, newValue){
      state.adminUsers = newValue;
    },
    addAdminUser(state, Payload){
      state.adminUsers.push(Payload);
    },
  },
  actions: {
    loadAdminUsers({commit,state}, businessId){
     
      var s=state;
      return new Promise((resolve, reject)=> {
        this.dispatch("getTokenConfig").then(function(config){
          axios.get(s.url + "Account/" + businessId + "/users", config).then((response)=>{
            commit("setAdminUsers", response.data);
          });
        });
      });
      
    },
    createAdminUserInvite({commit, state}, PayLoad){
      var s=state;
      return new Promise((resolve, reject)=>{
        this.dispatch("getTokenConfig").then(function(config){
          axios.post(s.url + "Account/"+PayLoad.BusinessId+"/users", PayLoad,config).then((response)=>{
            commit("addAdminUser", response.data);
          });
        });
      });
    },
    changeUser({commit}, user){

      commit('setUserLoaded', true);

      commit("SET_LOGGED_IN", user !== null);
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email
        });
      } else {
        commit("SET_USER", null);
      }


    },
    updateLocation({commit, state}, Payload){
      var s=state;
      var t = this;
      return new Promise((resolve, reject)=> {
        this.dispatch("getTokenConfig").then(function(config){
    
          axios.put( 
            s.url  + "locations/" + Payload.LocationID,
            Payload.UpdateLocationDTO, 
             config
          ).then((response) => {
              if(response.data==1){
                commit('setLocation', Payload)
              }
          
              resolve(response.data);
    
          }).catch((error) => {
              console.log("error:" + error)
          });
          

        });
      });
    },
    returnLocationCheckIns({commit, state},locationID){
      var t =state;
      return new Promise((resolve, reject) => {


        firebase.auth().currentUser.getIdToken().then(function(idToken) { 
          var config = {
                  headers: {'Authorization': "bearer " + idToken}
          };     
       axios.get( 
         t.url  + 'locations/' + locationID + "/CheckIns",
          config
      ).then((response) => {

      
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });

    },
    addLocation({commit, state}){
      var t =this;
      var s = state;
  

      
      return new Promise((resolve, reject) => {


        t.dispatch("getTokenConfig").then(function(config) { 
       axios.post( 
        s.url  + "locations",
         {}, 
         config
      ).then((response) => {

          commit('addLocation', response.data)
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });
    },
    addQRCode({commit, state}, qrCode){
      var t =state;
      return new Promise((resolve, reject) => {


        firebase.auth().currentUser.getIdToken().then(function(idToken) { 
          var config = {
                  headers: {'Authorization': "bearer " + idToken}
          };     
       axios.post( 
         t.url  + 'locations/' + qrCode.LocationID + "/QRCodes",
         qrCode, 
         config
      ).then((response) => {

      
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });
    },
    returnQRCodes({commit, state},locationID){
      var t =state;
      return new Promise((resolve, reject) => {


        firebase.auth().currentUser.getIdToken().then(function(idToken) { 
          var config = {
                  headers: {'Authorization': "bearer " + idToken}
          };     
       axios.get( 
         t.url  + 'locations/' + locationID + "/QRCodes",
          config
      ).then((response) => {

      
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });

    },
    getTokenConfig({commit, state}){

      return new Promise((resolve,reject)=>{
        if(state.idToken==""){
        return firebase.auth().currentUser.getIdToken().then(function(idToken){
            state.idToken = idToken;
            resolve({
                headers: {'Authorization': "bearer " + idToken}
              });
        });        
      }else{
        resolve({
            headers: {'Authorization': "bearer " + state.idToken}
          });
      };
    });
    },
    getToken({commit, state}){
      return new Promise((resolve,reject)=>{
        if(state.idToken==""){
        return firebase.auth().currentUser.getIdToken().then(function(idToken){
            state.idToken = idToken;
            resolve(idToken);
        });        
      }else{
        resolve(state.idToken);
      };
    });
    },
    loadAccount({commit, state}){
      var t =this;
      var s = state;
  
     
      
      return new Promise((resolve, reject) => {


        t.dispatch("getTokenConfig").then(function(config) { 


       axios.get( 
        s.url  + "Account",
         config
      ).then((response) => {

          commit('setAccount', response.data)
          resolve(response.data);

      }).catch((error) => {
          console.log("error:" + error)
      });

      });
    });

    
    },
    loadClients({commit, state}){
     
      var t =state;

      return new Promise((resolve, reject) => {

          if(state.clientsLoaded){
              resolve(state.clients);
          }else{

                 firebase.auth().currentUser.getIdToken().then(function(idToken) { 
                  var config = {
                          headers: {'Authorization': "bearer " + idToken}
                  };     
               axios.get( 
                 t.url  + 'Business/' +  state.selectedBusiness +"/Locations",
                  config
              ).then((response) => {
  
                  state.locations= response.data;
                  state.locationsLoaded  =true;
                  commit("loadLocations", response.data);
                  resolve(state.locations);
  
              }).catch((error) => {
                  console.log("error:" + error)
              });
          });
          }
      });
  },
  },
  getters:{
    returnUser:state=>
    {
      return state.user;
    },
    returnAdminUsers: state=>
    {
      return state.adminUsers;
    },
    returnUserLoaded:state=>
    {
      return state.userLoaded;
    },
    getLocationByID: (state) => (id) => {

       var item = state.locations.find(location => location.id === id);
       if(item !=null){
       return item;
       }else{
         return {title:"Not Specified"}
       }
      },
    returnAccount:state=>
    {
      return state.accountDetails;
    },
    getLocations:state=>{
        return state.locations;
    },
    getIdToken: state=>{
      return state.idToken;
    },
    getAxiosConfig: state=>{


        return {
          headers: { Authorization: "Bearer " + state.idToken }
        }
      

        },
        getAxiosConfigBlob: state=>{
          return {
            headers: { Authorization: "Bearer " + state.idToken, responseType: 'blob' }
        }
        
  
          }
    }
      
  })
